import { render, staticRenderFns } from "./groupSet-edit.vue?vue&type=template&id=447a16c7&scoped=true&"
import script from "./groupSet-edit.vue?vue&type=script&lang=js&"
export * from "./groupSet-edit.vue?vue&type=script&lang=js&"
import style0 from "./groupSet-edit.vue?vue&type=style&index=0&id=447a16c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a16c7",
  null
  
)

export default component.exports